import objectPath from 'object-path'
import {
  IForm_SchemaField,
  IForm_Schema,
  IForm_Schema_Item,
} from '../types/schema/form'

export const defaultValues: Record<string, any> = {
  text: '',
  textarea: '',
  radio: '',
  checkbox: false,
  multipleCheckbox: {},
  select: '',
  list: [],
}

export const flattenSchema = (schema: IForm_Schema) => {
  return schema.reduce<IForm_SchemaField[]>((all, row) => {
    return row.constructor === Array ?
      all.concat(row) :
      all.concat([row as IForm_SchemaField])
  }, [])
}

export const isSchemaField = (field: IForm_Schema_Item): field is IForm_SchemaField => {
  return field.constructor !== Array
}

export const mapSchema = (schema: IForm_Schema, handler: {
  (field: IForm_SchemaField): IForm_SchemaField,
}): IForm_Schema => {
  return schema.map((row) => {
    if(isSchemaField(row)) {
      return handler(row)
    }
    else {
      return row.map(handler)
    }
  })
}

export const injectDefaultValues = (schema: IForm_Schema, values: any) => {
  const flatSchema = flattenSchema(schema)
  const returnValue = JSON.parse(JSON.stringify(values || {}))
  flatSchema.forEach(schemaEntry => {
    const useDefault = typeof(schemaEntry.default) !== 'undefined' ?
      schemaEntry.default :
      defaultValues[schemaEntry.component || 'text']
    objectPath.set(returnValue, schemaEntry.id, objectPath.get(returnValue, schemaEntry.id, useDefault))
  })
  return returnValue
}
